import { URLS } from "@app/shared";
import { MemberGrid, PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { boardOfDirectorsAtom } from "../atoms";

export function BoardOfDirectorsPage() {
  const { executiveManagement, boardOfDirectors } =
    boardOfDirectorsAtom.useValue();

  return (
    <>
      <PageHeader
        translationKey="boardOfDirectors"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("boardOfDirectors") },
        ]}
      />
      <div className="py-16">
        <MemberGrid
          title={trans("aboutUsPage.leadership.boardOfDirectors.title")}
          members={boardOfDirectors}
        />
        <MemberGrid
          title={trans("aboutUsPage.leadership.executiveManagement.title")}
          members={executiveManagement}
        />
      </div>
    </>
  );
}
